module.exports = __webpack_public_path__ + "fonts/baronsans-bold-webfont.2f855272.woff2";